export const MONO_STACK =
  'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'

const encoder = new TextEncoder()

export function toChars(value) {
  return Array.from(value || '')
}

export function diffChars(prev, next) {
  const before = toChars(prev)
  const after = toChars(next)
  let start = 0
  const min = Math.min(before.length, after.length)
  while (start < min && before[start] === after[start]) start += 1

  let endBefore = before.length
  let endAfter = after.length
  while (endBefore > start && endAfter > start && before[endBefore - 1] === after[endAfter - 1]) {
    endBefore -= 1
    endAfter -= 1
  }

  return {
    added: after.slice(start, endAfter),
    removed: endBefore - start,
  }
}

export function encodeChar(ch) {
  const bytes = encoder.encode(ch)
  const bits = new Array(bytes.length)
  for (let i = 0; i < bytes.length; i += 1) {
    bits[i] = bytes[i].toString(2).padStart(8, '0')
  }
  return bits
}

export function layoutTokens(tokens, maxWidth, tokenWidth, spaceWidth) {
  const lines = []
  let line = []
  let width = 0
  for (const token of tokens) {
    const add = line.length === 0 ? tokenWidth : spaceWidth + tokenWidth
    if (line.length > 0 && width + add > maxWidth) {
      lines.push(line)
      line = [token]
      width = tokenWidth
    } else {
      line.push(token)
      width += add
    }
  }
  if (line.length) lines.push(line)
  return lines
}
